import axios from "axios";
export async function downloadFile(src, filename, axiosParams) {
    const res = await axios(src, Object.assign({ method: 'GET', responseType: "blob" }, (axiosParams || {})));
    const url = window.URL
        .createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
